var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 70,
    fill: "#121516"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.6205 42H82.3645C86.0191 42.0043 88.9807 44.9657 88.9849 48.62V91.3795C88.9807 95.0342 86.0192 97.9957 82.3649 98H58.6205C54.9659 97.9957 52.0044 95.0343 52 91.3799V48.6205C52.0044 44.9658 54.9659 42.0042 58.6201 42H58.6205ZM82.3645 94.2666C83.9584 94.2652 85.2502 92.9735 85.2516 91.3797V48.6204C85.2501 47.0265 83.9583 45.7347 82.3646 45.7333H58.6205C57.0265 45.7347 55.7348 47.0264 55.7334 48.6203V91.3795C55.7348 92.9734 57.0265 94.2652 58.6203 94.2666H58.6205L82.3645 94.2666ZM63.3742 43.8666H77.6356V46.3555C77.6356 47.7301 76.5213 48.8444 75.1467 48.8444H65.7387C64.3641 48.8444 63.2499 47.7301 63.2499 46.3556V43.8666L63.3742 43.8666ZM72.8569 90.8817H68.1281V87.1484H72.8569V90.8817Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBlack);
export default __webpack_public_path__ + "static/media/phone-black.adbed4e32074cb8d20d298ccec7f5e57.svg";
export { ForwardRef as ReactComponent };